/**
 * Route Params Context
 * 
 * Provides route params to components rendered inside KeepAliveOutlet.
 * This is necessary because components are rendered outside React Router's
 * Route context, so useParams() from react-router-dom won't work.
 */

import { createContext, useContext } from 'react';

// Context to provide route params to components
export const RouteParamsContext = createContext<Record<string, string>>({});

/**
 * Hook to get route params from the custom context
 * Use this instead of useParams() when inside KeepAliveOutlet
 */
export const useRouteParams = () => useContext(RouteParamsContext);

